import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import Stack from '@mui/material/Stack';

const SubmitButton = (props) => {
	const { buttonText, disabled } = props;
	const styledProps = Object.assign({}, props);

	delete styledProps.buttonText;
	delete styledProps.isDisabled;

	const { t } = useTranslation('inputs');

	return (
		<FormControl sx={{ height: '100%' }} {...styledProps}>
			<Stack marginTop="8px">
				<Button
					disabled={disabled}
					type="submit"
					variant="contained"
					size="small"
				>
					{buttonText || t('submit.value')}
				</Button>
			</Stack>
		</FormControl>
	);
};

SubmitButton.propTypes = {
	buttonText: PropTypes.string,
	disabled: PropTypes.bool
};

export default SubmitButton;
